<div class="flex flex-wrap md:flex-nowrap justify-between w-full gap-2">
  <div class="notification-wrapper">
    <div class="notification-header">
      <span>{{getNotificationHeader(data)}}</span>
    </div>
    <div
      class="notification-subject line-clamp-1"
      [innerHTML]="getNotificationSubject(data)"
    ></div>
    <div
      class="notification-preview"
      [innerHTML]="getNotificationPreview(data)"
    ></div>
  </div>
  <div class="notification-time md:justify-end">
    <time-diff date="{{data.createdAt}}" style="white-space: nowrap"></time-diff>
  </div>
</div>
